import React from "react";
import {Route, Switch} from "react-router-dom";
import ChaQuotationsList from "./ChaQuotationsList";
import PostChaQuotationsDetails from "./PostChaQuotationsDetails";
import ChaQuotationsView from "./ChaQuotationsView";

const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={ChaQuotationsList}/>
      <Route path={`${match.url}/details/:id?`} component={PostChaQuotationsDetails}/>
      <Route path={`${match.url}/view/:id?`} component={ChaQuotationsView}/>
      <Route path={`${match.url}/clone/:id?`} component={PostChaQuotationsDetails}/>
    </Switch>
);

export default App;